import apiFetch from '../apiFetch'

export default function (token, documentId, organizedUnitId) {
  return apiFetch({ endPoint: `document/${documentId}/info?organizedUnitId=${organizedUnitId}`, method: 'GET', body: null, token: token })
}
